export default "__VITE_ASSET__JIWwyKeI__"